import { ENGINEERING_STACK_EMBED_TITLE } from "@/lib/careers-seo";
import type { FunnelContent } from "./developers-funnel-types";
import { SRC } from "./developers-funnel-types";

export const FUNNEL_CONTENT: FunnelContent = {
  hero: {
    topBar: "Apply in under a minute",
    heading: "We're looking for software developers",
    facts: ["100% remote", "Permanent contract", "40h/week"],
  },
  sections: [
    {
      id: "work",
      heading: "A software that reimagines an industry",
      intro:
        "The average German property manager uses 8+ software tools daily. We're building one tool to replace them all. Here's how you can help:",
      media: "product-mockup",
      bullets: [
        {
          icon: "inbox",
          title: "Our Product-Team",
          text: "Build & maintain features our customers use every day, like accounting, inbox, documents, videocalls, etc.",
        },
        {
          icon: "agent",
          title: "Our Agent-Team",
          text: "Automating an entire industry is a real challenge. Here's what we have so far: Knowledge base, 250+ Tools, Agent-Builder, Agent-Template-Sharing, Voice-Agents, ~10 System-Agents built-in.",
        },
      ],
    },
    {
      id: "offer",
      heading: "Why join us?",
      image: {
        src: SRC.office,
        alt: "Our office in Worms and a colleague at work",
        hint: "Team / office photo · 1600 × 1000",
        ratio: "16 / 10",
        caption: "Our office in Worms, Germany",
      },
      bullets: [
        {
          icon: "rocket",
          title: "Real impact & Ownership",
          text: "What you build goes live.",
        },
        {
          icon: "coins",
          title: "$1,000 to $3,000 a month",
          text: "Before taxes, with room to grow.",
        },
        {
          icon: "users",
          title: "Employed in your country",
          text: "A local employment contract where you live.",
        },
        {
          icon: "shield",
          title: "Allianz health insurance",
          text: "Included with your contract.",
        },
        {
          icon: "sparkles",
          title: "All the tokens you need",
          text: "Claude and Cursor, as much as you need.",
        },
        {
          icon: "agent",
          title: "AI first",
          text: "AI writes 100% of our code.",
        },
      ],
    },
    {
      id: "growth",
      heading: "We're just getting started",
      intro:
        "hausverwalter.ai launched in 2026. The first property management companies already use our product and are genuinely excited about it, even invested into the company. We're growing the team and are ready to scale.",
      media: "growth-chart",
      bullets: [],
    },
    {
      id: "stack",
      heading: "Our futuristic tech stack",
      intro:
        "Our tech stack allows us to move at the speed of AI. At the heart of it sits Convex. You'll love it because it enables you to *just build*.",
      embed: {
        src: SRC.architecture,
        title: ENGINEERING_STACK_EMBED_TITLE,
      },
      bullets: [
        {
          icon: "sparkles",
          title: "AI first",
          text: "Everything is TypeScript, even the database schema. Perfect for Agentic Engineering.",
        },
        {
          icon: "globe",
          title: "Realtime",
          text: "Convex queries are live subscriptions. Forget about polling loops & cache invalidation.",
        },
        {
          icon: "shield",
          title: "Correct by default",
          text: "Every Convex mutation runs as one serializable transaction and retries on conflict.",
        },
      ],
    },
  ],
  footer: {
    line: "hausverwalter.ai",
    youtube: "Product videos",
    imprint: "Imprint",
    privacy: "Privacy",
  },
};
